<div class="mt-5">
    <div class="welcome-screen mt-2 container-sm">
        <div class="row justify-content-center">
            <div class="col-md-12">
                <div class="card shadow-lg p-5 text-center card-custom">
                    <div class="text-center">
                        <h4 class="title mb-4"
                            *ngIf="!isTypeSignatureAnyThing">{{"TITLE.DOCUMENT-SIGNED" | translate}}</h4>
                        <h4 class="title mb-4"
                            *ngIf="isTypeSignatureAnyThing">{{"TITLE.DOCUMENT-REVIEWED" | translate}}</h4>
                        <div>
                            <label class="font-weight-bold">{{ "LABEL.FLOW" | translate }}</label> :
                            {{document._more.workflowDescription}}
                        </div>
                        <div>
                            <label class="font-weight-bold">{{ "LABEL.SUBJECT" | translate }}</label> :
                            {{document.subject}}
                        </div>
                        <div class="alert alert-success" *ngIf="isSuccessfully">
                                <span class="alert-icon"><i
                                        class="fa fa-check-circle text-success"></i></span>
                            <div class="alert-content font-weight-normal">
                                <h5 *ngIf="!isTypeSignatureAnyThing">{{"MESSAGE.DOCUMENT-SIGNED-SUCCESSFULLY" | translate}}</h5>
                                <h5 *ngIf="isTypeSignatureAnyThing">{{"MESSAGE.DOCUMENT-REVIEWED-SUCCESSFULLY" | translate}}</h5>
                            </div>
                        </div>
                        <div class="alert alert-danger" *ngIf="!isSuccessfully">
                                <span class="alert-icon"><i
                                        class="fa fa-check-circle text-danger"></i></span>
                            <div class="alert-content font-weight-normal">
                                <h5> {{messageAlert}}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <button class="btn btn-primary text-primary" (click)="downloadContract()"
                                data-toggle="tooltip" data-placement="top"
                                title="{{ 'BUTTON.DOWNLOAD-AGREEMENT' | translate }}"
                                *ngIf="isCloudSignature"><i
                                class="fa fa-download"></i> {{ "BUTTON.DOWNLOAD-AGREEMENT" | translate }} </button>
                    </div>
                    <div class="text-left"><label>
                        <b *ngIf="!isTypeSignatureAnyThing">{{"TITLE.DOCUMENT-SIGNED" | translate}}:</b>
                        <b *ngIf="isTypeSignatureAnyThing">{{"TITLE.DOCUMENT-REVIEWED" | translate}}:</b>
                    </label></div>
                    <div id="accordion">
                        <div class="card bg-color" *ngFor="let resource of resourceList; let index = index;">
                            <div id="heading{{index}}" [class.bg-selected]="index === activeIndex">
                                <h5 class="mb-0 text-left">
                                    <button class="w-100 btn btn-default text-left btn-hover"
                                            [class.bg-selected]="index === activeIndex"
                                            [attr.aria-expanded]="index === activeIndex"
                                            [attr.aria-controls]="'collapse' + index"
                                            (click)="toggle(index, resource)">
                                        <i class="far fa-file-pdf icon-size"></i>  {{resource.fileName}}
                                    </button>
                                </h5>
                            </div>
                            <div [id]="'collapse' + index"
                                 [class.collapse]="index !== activeIndex"
                                 [class.show]="index === activeIndex"
                                 [attr.aria-labelledby]="'heading' + index"
                                 data-parent="#accordion">
                                <div class="card-body">
                                    <app-pdf-viewer *ngIf="!reloadingPdf" [urlStream]="urlStream"
                                                    [rubricSrc]="defaultRubricSrc"
                                                    [showRubric]="false"
                                                    [resource]="resource"
                                                    [signComplete]="true"
                                                    [signatureDescriptions]="getListSignatureDescription()"
                                                    [typeSignature]="typeSignature"
                                                    [personId]="personId"
                                                    [isUser]="false"
                                                    [isLastOperator]="false"
                                                    [eventDragging]="eventsSubject.asObservable()">
                                    </app-pdf-viewer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-loading *ngIf="reloadingPdf || loading"></app-loading>
